import CTLUnReadCell from "application/components/CTLUnReadCell";
import RowAction from "application/components/RowAction";
import formControl from "globals/form-control";


const getUpdateColumns = (onDelete, onEdit) => {
  return [
    {
      Header: "Code Type",
      accessor: "codetype",
      displayInList: true,
      allowFilter: true,
      allowInForm: true,
      disabled: true,
      dataType: "string",
      Cell: ({ row, value }) => <CTLUnReadCell row={row} value={value} />,
    },
    {
      Header: "Short Code",
      accessor: "shortcode",
      displayInList: true,
      allowFilter: false,
      allowInForm: true,
      dataType: "string",
      Cell: ({ row, value }) => <CTLUnReadCell row={row} value={value} />,
    },
    {
      Header: "Description",
      accessor: "description",
      displayInList: true,
      allowFilter: false,
      allowInForm: true,
      dataType: "string",
      validation: formControl.string().required("Required"),
      Cell: ({ value }) => <CTLUnReadCell value={value} />,
    },
    {
      Header: "Action",
      accessor: "id",
      displayInList: true,
      sortDisable: true,
      Cell: ({ row, value }) => (
        <RowAction
          row={row}
          value={value}
          onDelete={onDelete}
          onEdit={onEdit}
        />
      ),
    },
  ];
};

export { getUpdateColumns};
